/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompanySpaceOrganizationUnitBulkCreateResponseOrganizationUnitLeadersInner } from './CompanySpaceOrganizationUnitBulkCreateResponseOrganizationUnitLeadersInner';
import {
    CompanySpaceOrganizationUnitBulkCreateResponseOrganizationUnitLeadersInnerFromJSON,
    CompanySpaceOrganizationUnitBulkCreateResponseOrganizationUnitLeadersInnerFromJSONTyped,
    CompanySpaceOrganizationUnitBulkCreateResponseOrganizationUnitLeadersInnerToJSON,
} from './CompanySpaceOrganizationUnitBulkCreateResponseOrganizationUnitLeadersInner';

/**
 * List of organization units in a company space, ordered by tree position. Optional category filters to 'department' or 'job_title'; omitted, both categories are returned as before. Pass search to match against code, name, or the name of a currently active leader/deputy (diacritics-insensitive). without_leader=true returns only units with no currently active leader or deputy; without_members=true returns only units with no user memberships at all - both can be combined with search. user_count reflects every membership, not just each user's primary workplace. organization_unit_leaders lists only the currently active leadership leader/deputy assignments for each unit; organization_unit_financial_approvers likewise lists only the currently active financial approver/deputy assignments - the two are entirely independent tracks, each with its own leader/deputy roles and time validity. PAGEABLE.
 * @export
 * @interface CompanySpaceOrganizationUnitIndexResponse
 */
export interface CompanySpaceOrganizationUnitIndexResponse {
    /**
     * 
     * @type {number}
     * @memberof CompanySpaceOrganizationUnitIndexResponse
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceOrganizationUnitIndexResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceOrganizationUnitIndexResponse
     */
    category: string;
    /**
     * 
     * @type {Date}
     * @memberof CompanySpaceOrganizationUnitIndexResponse
     */
    created_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof CompanySpaceOrganizationUnitIndexResponse
     */
    updated_at: Date;
    /**
     * 
     * @type {number}
     * @memberof CompanySpaceOrganizationUnitIndexResponse
     */
    user_count?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CompanySpaceOrganizationUnitIndexResponse
     */
    subtree_user_count?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompanySpaceOrganizationUnitIndexResponse
     */
    code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanySpaceOrganizationUnitIndexResponse
     */
    parent_id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CompanySpaceOrganizationUnitIndexResponse
     */
    position?: number | null;
    /**
     * 
     * @type {Array<CompanySpaceOrganizationUnitBulkCreateResponseOrganizationUnitLeadersInner>}
     * @memberof CompanySpaceOrganizationUnitIndexResponse
     */
    organization_unit_leaders?: Array<CompanySpaceOrganizationUnitBulkCreateResponseOrganizationUnitLeadersInner>;
    /**
     * 
     * @type {Array<CompanySpaceOrganizationUnitBulkCreateResponseOrganizationUnitLeadersInner>}
     * @memberof CompanySpaceOrganizationUnitIndexResponse
     */
    organization_unit_financial_approvers?: Array<CompanySpaceOrganizationUnitBulkCreateResponseOrganizationUnitLeadersInner>;
}

/**
 * Check if a given object implements the CompanySpaceOrganizationUnitIndexResponse interface.
 */
export function instanceOfCompanySpaceOrganizationUnitIndexResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "created_at" in value;
    isInstance = isInstance && "updated_at" in value;

    return isInstance;
}

export function CompanySpaceOrganizationUnitIndexResponseFromJSON(json: any): CompanySpaceOrganizationUnitIndexResponse {
    return CompanySpaceOrganizationUnitIndexResponseFromJSONTyped(json, false);
}

export function CompanySpaceOrganizationUnitIndexResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanySpaceOrganizationUnitIndexResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'category': json['category'],
        'created_at': (new Date(json['created_at'])),
        'updated_at': (new Date(json['updated_at'])),
        'user_count': !exists(json, 'user_count') ? undefined : json['user_count'],
        'subtree_user_count': !exists(json, 'subtree_user_count') ? undefined : json['subtree_user_count'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'parent_id': !exists(json, 'parent_id') ? undefined : json['parent_id'],
        'position': !exists(json, 'position') ? undefined : json['position'],
        'organization_unit_leaders': !exists(json, 'organization_unit_leaders') ? undefined : ((json['organization_unit_leaders'] as Array<any>).map(CompanySpaceOrganizationUnitBulkCreateResponseOrganizationUnitLeadersInnerFromJSON)),
        'organization_unit_financial_approvers': !exists(json, 'organization_unit_financial_approvers') ? undefined : ((json['organization_unit_financial_approvers'] as Array<any>).map(CompanySpaceOrganizationUnitBulkCreateResponseOrganizationUnitLeadersInnerFromJSON)),
    };
}

export function CompanySpaceOrganizationUnitIndexResponseToJSON(value?: CompanySpaceOrganizationUnitIndexResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'category': value.category,
        'created_at': (value.created_at.toISOString()),
        'updated_at': (value.updated_at.toISOString()),
        'user_count': value.user_count,
        'subtree_user_count': value.subtree_user_count,
        'code': value.code,
        'parent_id': value.parent_id,
        'position': value.position,
        'organization_unit_leaders': value.organization_unit_leaders === undefined ? undefined : ((value.organization_unit_leaders as Array<any>).map(CompanySpaceOrganizationUnitBulkCreateResponseOrganizationUnitLeadersInnerToJSON)),
        'organization_unit_financial_approvers': value.organization_unit_financial_approvers === undefined ? undefined : ((value.organization_unit_financial_approvers as Array<any>).map(CompanySpaceOrganizationUnitBulkCreateResponseOrganizationUnitLeadersInnerToJSON)),
    };
}

